import { fromJS } from 'immutable'

import {
  EXPIRED_EXTEND_TRIAL_GET,
  EXPIRED_EXTEND_TRIAL_UPDATE,
  EXPIRED_EXTEND_TRIAL_ERROR,
} from 'actions/expired'

// Reducer
// ---------------------------------------------------------------------------

export const initialState = fromJS({
  error: false,
  errorData: null,
  loading: false,
  returnData: null,
})

export default function createExpiredReducer(state = initialState, action) {
  switch (action.type) {
    case EXPIRED_EXTEND_TRIAL_GET:
      return _getExpiredExtendTrial(state)
    case EXPIRED_EXTEND_TRIAL_UPDATE:
      return _updateExpiredExtendTrial(state, action.payload)
    case EXPIRED_EXTEND_TRIAL_ERROR:
      return _errorExpiredExtendTrial(state, action.payload)
    default:
      return state
  }
}

const _getExpiredExtendTrial = state => {
  return state.update('loading', () => true)
}

const _updateExpiredExtendTrial = (state, payload) => {
  return state
    .set('returnData', fromJS(payload.data))
    .update('loading', () => false)
    .update('error', () => false)
    .update('errorData', () => null)
}

const _errorExpiredExtendTrial = (state, payload) => {
  return state
    .set('error', payload.error)
    .set('errorData', fromJS(payload.data))
    .update('loading', () => false)
}
